import request from '../../utils/requests'

const baseUrl = '/api/ClassDayTimeRelationStudent'


/**
 * 获取固定学生列表
 * @param {*} params 
 * @returns 
 */
async function _getClassDayTimeRelationStudentList(params) {
  return request(baseUrl + '/GetClassDayTimeRelationStudentList', {
    method: 'GET',
    params
  })
}

async function _getRelationStudentList(params) {
  return request(baseUrl + '/GetRelationStudentList', {
    method: 'GET',
    params
  })
}

/**
 * 保存固定学生
 * @param {*} params 
 * @returns 
 */
async function _saveClassDayTimeRelationStudent(params) {
  return request(baseUrl + '/SaveClassDayTimeRelationStudent', {
    method: 'POST',
    body: params
  })
}



export default {
  _getClassDayTimeRelationStudentList,
  _getRelationStudentList,
  _saveClassDayTimeRelationStudent
}







// WEBPACK FOOTER //
// ./src/services/classDayTimeRelationStudent.js